import type { ComboBoxOption } from '../../../cdl/ComboBox/ComboBox';
import type { ComboBoxOptionComponentProps } from '../../../cdl/ComboBox/types/ComboBoxComponentProps';
import { Tag } from '../../../cdl/Tag/Tag';
import { Text } from '../../../cdl/Text/Text';
import { Box } from '../../../common/ui/Box';

export const SupplierGroupOption = ({ option }: ComboBoxOptionComponentProps<ComboBoxOption>) => {
    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            width="100%"
            height={40}
            gap={8}
            minWidth={0}
        >
            <Text
                display="block"
                style={{
                    flexShrink: 1,
                    minWidth: 0,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                }}
            >
                {option.label}
            </Text>
            <Box flexShrink={0}>
                <Tag variant="default">{option.value}</Tag>
            </Box>
        </Box>
    );
};
